import React from 'react';
import img from '../images/404.png'
const NotFound = () => {
    return (
        <div className='w-100 ' >
            <img className='w-100'  src={img} alt="" />
        </div>
    );
};

export default NotFound